import Vue from 'vue'

export const EVENT = {
  STORAGE: {
    SYNC: 'storage-sync',
  },
}

export const eventBus = new Vue()
